import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["coverImage", "mainImage", "productData", "productImages"]
  static values = {
    delay: { type: Number, default: 2000 },
    duration: { type: Number, default: 1000 }
  }

  connect() {
    this.handleImageLoad = () => {
      if (this.adjustOnLoad) {
        this.scheduleAdjustment(0, 0)
      } else {
        this.scheduleInitialAdjustment()
      }
    }

    this.coverImageTarget.addEventListener("load", this.handleImageLoad)
    this.element.dataset.productCoverReady = "true"

    if (this.coverImageTarget.complete) this.scheduleInitialAdjustment()
  }

  disconnect() {
    this.coverImageTarget.removeEventListener("load", this.handleImageLoad)
    this.clearTimers()
    delete this.element.dataset.productCoverAdjusted
    delete this.element.dataset.productCoverReady
  }

  resize() {
    this.adjustOnLoad = true
    this.scheduleAdjustment(0, 0)
  }

  scheduleInitialAdjustment() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.scheduleAdjustment(
      reduceMotion ? 0 : this.durationValue,
      reduceMotion ? 0 : this.delayValue
    )
  }

  scheduleAdjustment(duration, delay) {
    this.clearTimers()

    if (!this.coverImageTarget.complete || this.coverImageTarget.naturalHeight === 0) return

    this.adjustOnLoad = false

    if (window.innerWidth < 768) {
      this.resetLayout()
      return
    }

    if (window.scrollY >= 20) {
      duration = 0
      delay = 0
    }

    this.adjustmentTimer = window.setTimeout(() => this.adjustLayout(duration), delay)
  }

  adjustLayout(duration) {
    const coverHeight = this.coverImageTarget.getBoundingClientRect().height
    const imageMargin = (coverHeight - ((270 * coverHeight) / 580)) / 2
    const imageGap = this.mainImageTarget.getBoundingClientRect().height - this.productDataTarget.getBoundingClientRect().height
    const transition = duration > 0 ? `margin ${duration}ms ease` : "none"

    this.coverImageTarget.style.transition = transition
    this.coverImageTarget.style.marginTop = `${-Math.abs(imageMargin)}px`
    this.coverImageTarget.style.marginBottom = `${-Math.abs(imageMargin)}px`
    this.productImagesTarget.style.transition = transition
    this.productImagesTarget.style.marginTop = `${imageGap > 0 ? -Math.abs(imageGap) : 0}px`
    this.element.dataset.productCoverAdjusted = "true"

    this.refreshTimer = window.setTimeout(() => this.refreshGallery(), duration)
  }

  resetLayout() {
    this.coverImageTarget.style.transition = "none"
    this.coverImageTarget.style.marginTop = "0px"
    this.coverImageTarget.style.marginBottom = "0px"
    this.productImagesTarget.style.transition = "none"
    this.productImagesTarget.style.marginTop = "0px"
    this.element.dataset.productCoverAdjusted = "true"
    this.refreshGallery()
  }

  refreshGallery() {
    document.dispatchEvent(new CustomEvent("product-gallery:refresh"))
  }

  clearTimers() {
    window.clearTimeout(this.adjustmentTimer)
    window.clearTimeout(this.refreshTimer)
  }
}
